import React from "react";

import { EMPTY_STRING, COLOR } from "../../constants";
import CustomSvg from "../../shared/components/custom-svg/CustomSvg";

const PropertyList = ({
  name,
  propertiesCount,
  icon,
  id,
  selected,
  handleSelection,
}) => {
  return (
    <div
      className={`property-card pointer ${
        selected ? "property-card-selected" : EMPTY_STRING
      }`}
      onClick={() => handleSelection(id)}
    >
      <CustomSvg
        src={icon}
        className="property-icon"
        color={selected ? COLOR.TEAL : COLOR.NAVY_BLUE}
      />
      <h6 className="text-break">{name}</h6>
      <p>{propertiesCount} Properties</p>
    </div>
  );
};

export default PropertyList;
